exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.client-type-selector .is-selected{\n  background-color: #B9F419 !important;\n}\n.custom-quote-button {\n  background-color: #B9F419 !important;\n  border-color: #B9F419 !important;\n  color: #000 !important;\n  height: 50px;\n  margin-top: 20px;\n}\n.custom-quote-button:hover {\n  background-color: #d4ff4f !important;\n  border-color: #d4ff4f !important;\n}\n.custom-quote-button:active {\n  background-color: #a3d90f !important;\n  border-color: #a3d90f !important;\n}\n", ""]);

// exports
